import { FC } from 'react';

import { Box, BoxProps } from '@mui/material';

export const Flex: FC<BoxProps> = ({ children, ...rest }) => (
    <Box {...rest} display="flex">
        {children}
    </Box>
);
